import { useState } from 'react';

export const useRxSorting = (data: any) => {
  const [sortState, setSortState] = useState({
    field: '',
    direction: null as -1 | 1 | null,
  });

  const getSeverityScore = (severity: string): number => {
    const s = severity.toUpperCase();
    return s === 'HIGH' ? 3 : s === 'MEDIUM' ? 2 : 1;
  };

  const getSortedRxData = (params: any) => {
    const direction =
      sortState.field === params.sortField && sortState.direction === 1
        ? -1
        : 1;
    const field = params.sortField;

    const items = [...data].sort((a, b) => {
      if (params.sortField === 'severity') {
        return (
          direction *
          Math.sign(getSeverityScore(a.severity) - getSeverityScore(b.severity))
        );
      } else if (params.sortField === 'fillDateRange') {
        return direction * (a.fillDates[0] || '').localeCompare(b.fillDates[0]);
      } else if (params.sortField === 'physician') {
        return direction * (a.doctor?.name || '').localeCompare(b.doctor.name);
      }

      return 1;
    });

    setSortState({ field, direction });

    return { items };
  };

  return {
    sortFields: ['severity', 'fillDateRange', 'physician'],
    sortFunction: getSortedRxData,
  };
};
